"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _KYC = _interopRequireDefault(require("../KYC"));
var _KYC_IMLegacyLevelsContainer = _interopRequireDefault(require("./KYC_IMLegacyLevelsContainer"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var KYC_IMLegacyComponent = function KYC_IMLegacyComponent() {
  return /*#__PURE__*/_react["default"].createElement(_KYC["default"], {
    LevelsComponent: _KYC_IMLegacyLevelsContainer["default"]
  });
};
var _default = exports["default"] = KYC_IMLegacyComponent;